import React from 'react';
import { useState, useRef, useEffect } from "react";
import Slider from 'react-slick';
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
function ProductBenifits({data}) { 
  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: data?.length,
    slidesToScroll: 1,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
  }

  const settings1 = {
    dots: false,
    infinite: false,
    arrows: false,
    responsive: [
      {
          breakpoint: 768,
          settings: {
            autoplay: true,
            dots: true,
            autoplaySpeed: 5000,
            adaptiveHeight: true,
          },
      },
  ],
  }
  
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  let sliderRef1 = useRef(null);
  let sliderRef2 = useRef(null);

  useEffect(() => {
    setNav1(sliderRef1);
    setNav2(sliderRef2);
  }, []);


  return (
    <>
      <section className='product-benifits'>
        <div className='container'>
          <div className='top-head'>
            <h2 className='ttl1'>Benefits</h2>
          </div>
          <div className='prod-benifit-wrap'>
              <div className='prd-list'>
                  
                  <Slider
                        {...settings}
                        asNavFor={nav1}
                        ref={slider => (sliderRef2 = slider)}
                        
                        swipeToSlide={true}
                        focusOnSelect={true}
                      >
                      {data.map((response, index) => (
                        <div key={index}>
                          <h3>{response.BenifitsHeading}</h3>
                        </div>
                      ))}
                    </Slider>
              </div>  
              <div className='prd-itm'>
                <Slider {...settings1} asNavFor={nav2} ref={slider => (sliderRef1 = slider)}>
                {data.map((response, index) => (
                    <div key={index}>
                        <h3>{response.BenifitsHeading}</h3>
                        <img src={response.BenifitsImg} width={682} height={437} alt={response.BenifitsHeading} />
                    </div>
                ))}
                  </Slider>

              </div>
          </div>
        </div>
      </section>
    </>

  )
}

export default ProductBenifits;
